import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShoppingCart, X } from 'lucide-react';
import { useCart, TOUCHED_KEY } from '../context/CartContext';

// For returning visitors we have no email for: if they come back to a cart
// they left at least an hour ago, say so once per visit. Never on the cart or
// checkout pages, where the cart is already in front of them.
const AWAY_MS = 60 * 60 * 1000;
const SEEN_KEY = 'sv_cart_banner_seen';

export default function CartWaitingBanner() {
  const { itemCount } = useCart();
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (sessionStorage.getItem(SEEN_KEY)) return;
      const touched = Number(localStorage.getItem(TOUCHED_KEY) || 0);
      if (itemCount > 0 && touched && Date.now() - touched > AWAY_MS) {
        setShow(true);
        sessionStorage.setItem(SEEN_KEY, '1');
      }
    } catch { /* storage blocked: skip the banner */ }
    // Only evaluated on arrival, not on every cart change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!show || itemCount === 0 || pathname === '/cart' || pathname === '/checkout') return null;

  return (
    <div className="sv-container" style={{ paddingTop: 12 }}>
      <div style={{
        display: 'flex', alignItems: 'center', gap: 12,
        border: '1px solid var(--accent)', borderRadius: 'var(--radius)',
        background: 'var(--surface)', padding: '12px 14px',
      }}>
        <ShoppingCart size={18} style={{ color: 'var(--accent)', flexShrink: 0 }} />
        <div style={{ flex: 1, fontSize: '0.9rem' }}>
          Your cards are still waiting to be ripped.
        </div>
        <Link to="/cart" className="sv-btn" style={{ padding: '8px 14px', fontSize: '0.85rem' }}>View cart</Link>
        <button
          onClick={() => setShow(false)}
          aria-label="Dismiss"
          style={{ background: 'transparent', border: 'none', color: 'var(--text-muted)', padding: 4, display: 'flex' }}
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
